import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '../../../i18n';

const app = document.getElementById('map-component');
console.log({app});
ReactDOM.render(
  <App data={app.dataset} />,
  app
);
